/**
 * headerNavActive — is a header nav icon the CURRENT section?  (ISP-9999)
 *
 * Gordon (2026-08-12): "When you're in the Chat section, the chat icon in the
 * header should look SELECTED (the same gray shadow-highlight as the hover
 * effect) ... true for ALL header icons." Each top-header nav icon
 * (Capture / Chat / Discover / Following) must show the SELECTED state while
 * the app is on that icon's destination.
 *
 * The routing decision is the part worth asserting, so it lives here as a pure,
 * DB-free, React-free function apart from the components that render it — the
 * same split this Header dir already uses for discoverEntryTarget.js.
 */

/**
 * True when `pathname` is inside the section rooted at `target`.
 *
 * Matches the target exactly OR as a path segment prefix, so a detail route
 * counts as "in the section": `/capture` is active on `/capture` and
 * `/capture/123`, but NOT on `/capturex` (a different route that merely shares
 * the string prefix). Fails closed on any missing/blank input.
 *
 * @param {string} pathname current location pathname (e.g. from useLocation)
 * @param {string} target   the icon's destination route (e.g. "/capture")
 * @returns {boolean}
 */
export const isSectionActive = (pathname, target) => {
  if (!pathname || !target) return false;
  return pathname === target || pathname.startsWith(target + "/");
};
